const AppEnvironment = {
  Production: 'prod',
  Development: 'dev',
} as const;

export const isProduction = () => window._env_.VITE_APP_ENVIRONMENT === AppEnvironment.Production;

const isDevelopment = () => window._env_.VITE_APP_ENVIRONMENT === AppEnvironment.Development;

// Assuming that any other value for VITE_APP_ENVIRONMENT represents the local environment
export const isLocal = () => !isProduction() && !isDevelopment();

export const isTest = () => process.env?.VITEST === 'true';

export const isEmbedded = () => window.self !== window.top;

export const isE2ESession = () => typeof window !== 'undefined' && window.__E2E_TEST__ === true;
